import * as React from 'react';

import { useOfferContext } from '../../../context';
import {
  getTotalArea,
  getKitchenArea,
  getLivingArea,
  getRoomArea,
  getLandArea,
  getMinArea,
  getWithSquareMeters,
  isCommercial,
  isFlat,
  isFlatShared,
  isRoom,
  isSuburban,
} from '../../../utils/offers';
import { Area } from 'shared/components/OfferCard/Area';

export const OfferAreaContainer = () => {
  const { offer } = useOfferContext();

  const { category, totalArea, offerType, roomArea, kitchenArea, livingArea, land, minArea } = offer;

  const texts = React.useMemo(() => {
    const totalAreaFormatter = getTotalArea(Number(totalArea));
    const kitchenAreaFormatter = isFlat(offerType ?? undefined) && getKitchenArea(Number(kitchenArea));
    const livingAreaFormatter = isFlat(offerType ?? undefined) && getLivingArea(Number(livingArea));
    const roomAreaFormatter = getRoomArea(Number(roomArea));
    const landAreaFormatter = isSuburban(category) && getLandArea(land ?? undefined);
    const minAreaFormatter = isCommercial(offerType ?? undefined) && getMinArea(Number(minArea));

    const props = {
      isFlatShared: isFlatShared(category),
      isRoom: isRoom(category),
      isFlat: isFlat(offerType ?? undefined),
      isSuburban: isSuburban(category),
      isCommercial: isCommercial(offerType ?? undefined),
      totalArea: totalAreaFormatter,
      kitchenArea: kitchenAreaFormatter,
      livingArea: livingAreaFormatter,
      roomArea: roomAreaFormatter,
      landArea: landAreaFormatter,
      minArea: minAreaFormatter,
    };

    const texts = [];

    if (props.isFlat && roomArea) {
      texts.push(getWithSquareMeters(roomArea));
    } else if (props.totalArea) {
      texts.push(getWithSquareMeters(props.totalArea));
    }

    if (props.kitchenArea) {
      texts.push(getWithSquareMeters(props.kitchenArea));
    }

    if (props.landArea) {
      texts.push(props.landArea);
    }

    if (props.livingArea) {
      texts.push(getWithSquareMeters(props.livingArea));
    }

    if (props.minArea) {
      texts.push(getWithSquareMeters('можно частями'));
      texts.push(getWithSquareMeters(`от ${getWithSquareMeters(minArea ?? undefined)}`));
    }

    if ((props.isFlatShared || props.isRoom) && props.totalArea) {
      texts.push(`общая ${getWithSquareMeters(props.totalArea)}`);
    }

    return texts.map((text, index, arr) => `${text}${index === arr.length - 1 ? '' : ',\u00A0'}`);
  }, [category, kitchenArea, land, livingArea, minArea, offerType, roomArea, totalArea]);

  return <Area texts={texts} />;
};
